<template>
  <div class="app-container bj-label-colon">
    <BjDivider
      >{{ $t('BusinessStockSynchronizationAdd.title') }}
      <template v-slot:button>
        <el-button type="primary" @click="$refs.dialogList.show()">{{ $t('BusinessStockSynchronizationAdd.titleBtn') }}</el-button>
      </template>

      <template v-slot:right>
        <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleConfirm('form')">{{ $t('saveText') }}</el-button>
      </template>
    </BjDivider>

    <el-form>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockSynchronizationAdd.code')">
            <span class="tips">{{ $t('BusinessStockSynchronizationAdd.codeText') }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockSynchronizationAdd.logicBinCode')">
            {{ info.code }}
            <span v-if="!info.code" class="tips">{{ $t('BusinessStockSynchronizationAdd.codeSelect') }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockSynchronizationAdd.name')">
            {{ info.name }}
            <span v-if="!info.name" class="tips">{{ $t('BusinessStockSynchronizationAdd.nameText') }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('table.remarkText')">
            <BjTextarea v-model="info.remark" :placeholder="$t('table.remarkText')" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <BjDivider
      >{{ $t('BusinessStockSynchronizationAdd.commodityDetails') }}
      <template v-slot:button>
        <el-button type="primary" @click="dialogListGoodsShow()">{{ $t('BusinessStockSynchronizationAdd.selectProduct') }}</el-button>

        <el-button
          :disabled="selectedRow.length == 0"
          type="primary"
          @click="onDelSelected()"
          >{{ $t('BusinessStockSynchronizationAdd.delProduct') }}</el-button
        >
        <!-- <el-button type="primary" class="xs">{{$t('orderNewPatch.Import')}}</el-button> -->
      </template></BjDivider
    >
    <el-table
      ref="multipleTable"
      :data="tableData"
      stripe
      border
      :header-cell-style="$rowStyle.DEFAULT"
      row-key="BJ_EBC_ID"
      max-height="600px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center" />

      <el-table-column type="index" align="center" width="60" :label="$t('table.countText')" />

      <el-table-column prop="categoryName" align="center" :label="$t('goodsPage.categoryName')" />
      <!-- <el-table-column prop="spuCode" align="center" :label="$t('goodsPage.spuCode')" /> -->

      <!-- <el-table-column prop="spuName" align="center" :label="$t('goodsPage.spuName')" />-->
      <el-table-column prop="skuCode" align="center" :label="$t('goodsPage.skuCode')" />
      <el-table-column prop="skuName" align="center" :label="$t('goodsPage.skuName')" />
      <el-table-column prop="num" align="center" :label="$t('BusinessStockSynchronizationAdd.num')">
        <template slot-scope="{ row }">
          <el-input-number v-model="row.num" :precision="0" :controls="false" class="full-width" />
        </template>
      </el-table-column>
    </el-table>

    <BjDialogList
      ref="dialogList"
      :config="$BjDialogListConfig.stockWarehouseLogic()"
      @confirm="onConfirmDialogList"
    />
    <BjDialogList
      ref="dialogListGoods"
      :config="$BjDialogListConfig.skuDefault()"
      multiple
      @confirm="onConfirmDialogListGoods"
    />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { stockApi } from '@/api';

export default {
  name: 'BusinessStockSynchronizationAdd',
  mixins: [viewMiXin],
  data() {
    return {
      info: {
        name: null,
        code: null,
        remark: null,
      },

      tableData: [],

      selectedRow: [],
    };
  },
  computed: {},
  methods: {
    dialogListGoodsShow() {
      // this.dialogListConfigGoods.defaultQuery.warehouseCode = this.info.code;
      this.$refs.dialogListGoods.show();
    },
    handleSelectionChange(d) {
      this.selectedRow = [].concat(d);
    },
    // 获取info
    onConfirmDialogList(data) {
      this.info.id = data[0].id;
      this.info.code = data[0].code;
      this.info.name = data[0].name;
    },
    onConfirmDialogListGoods(data) {
      data.forEach(row => {
        const FLAG = this.tableData.find(e => e.id == row.id);
        if (!FLAG && row.id) {
          // type 默认1：增加
          this.tableData.push({ ...row, num: undefined, type: 1 });
        }
      });
    },

    onDelSelected() {
      this.selectedRow.forEach(row => {
        this.tableData.splice(
          this.tableData.findIndex(e => e.id == row.id),
          1,
        );
      });
      // 清除选中状态
      this.$refs.multipleTable.clearSelection();
    },
    reFresh() {
      this.$emit('reFresh');
    },
    handleConfirm(formName) {
      if (!this.info || !this.info.id || !this.info.code) {
        this.$message.warning(this.$t('BusinessStockSynchronizationAdd.msgWarning1'));
        return;
      }

      if (this.tableData.length == 0) {
        this.$message.warning(this.$t('BusinessStockSynchronizationAdd.msgWarning2'));
        return;
      }

      if (this.tableData.some(e => !e.type || !e.num || e.num == 0)) {
        this.$message.warning(this.$t('BusinessStockSynchronizationAdd.msgWarning3'));
        return;
      }
      const API_DATA = {
        // adjustCode: 'string',
        adjustDetailsReqDTOList: this.tableData.map(e => {
          return {
            num: e.num,
            skuCode: e.skuCode,
            tenantId: this.$store.getters.tenantId,
            type: e.type,
          };
        }),
        // id: 0,
        remark: this.info.remark,
        warehouseCode: this.info.code,
        warehouseId: this.info.id,
      };

      this.addApi(API_DATA);
    },

    addApi(API_DATA) {
      stockApi.addAdjustRecords(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.complete('BusinessStockSynchronization');
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
